export const PERMS = {
    READ: 'report_cost_center_costs.read',
    EXPORT: 'report_cost_center_costs.export',
}
